// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3-AfH","author":"Table_author__22Fi6","authorImage":"Table_authorImage__1gXqP","unreadRow":"Table_unreadRow__3L-xh"};